/**
 * Presence plugin: emits a privacy-safe `traffic_presence` event once per tab session.
 *
 * This allows the platform to show aggregate traffic and consent states without
 * creating a stable visitor profile before consent is granted.
 */
import type { PluginContext } from "../lib/types";

import { registerPlugin } from "./register";

function getSessionFlag(key: string): boolean {
  try {
    if (typeof sessionStorage === "undefined") return false;
    if (sessionStorage.getItem(key)) return true;
    sessionStorage.setItem(key, "1");
    return false;
  } catch {
    return false;
  }
}

registerPlugin("presence", (ctx: PluginContext) => {
  const flagKey = `prospix_traffic_presence_${ctx.siteKey || "default"}`;

  return {
    onInit() {
      if (!ctx.canTrack("essential")) return;
      if (getSessionFlag(flagKey)) return;
      ctx.track("traffic_presence");
    },
  };
});
